import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-4">
            成为第一个吃瓜群众
          </h2>
          <p className="text-foreground-400 text-sm md:text-base mb-8 max-w-md">
            订阅51爆料，第一时间获取热点大瓜，绝不掉队
          </p>
          <Link
            to="/category/wanghong-fanche"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer group"
          >
            立即进入吃瓜现场
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>

        <div className="mt-12 md:mt-16 overflow-hidden">
          <div className="flex items-center gap-6 md:gap-10 opacity-20">
            {['爆料', '吃瓜', '独家', '真相', '热点', '内幕', '追踪'].map((word, i) => (
              <span
                key={i}
                className="font-heading text-3xl md:text-5xl font-black text-foreground-950 whitespace-nowrap select-none"
              >
                {word}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}